import type { ReactNode } from 'react';
import { Footer } from './Footer.tsx';
import { Header } from './Header.tsx';

interface Props {
  readonly children: ReactNode;
}

export function PublicLayout({ children }: Props): JSX.Element {
  return (
    <div className="min-h-screen bg-linen text-ink">
      <Header />
      <main>{children}</main>
      <Footer />
    </div>
  );
}
